import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';

import './App.css';

import PrivateRoute from './components/PrivateRoute';
import Login from './components/Login';
import Home from './components/Home';
import NoMatch from './components/NoMatch';

// const App = ({ authenticated, checked }) => (
//   <Router>
//     { checked &&
//       <Switch>
//         <Route path="/(login|signup|forgot)/" component={Login}/>
//         <PrivateRoute path="/" component={Home} authenticated={authenticated}/>
//         <Route component={NoMatch}/>
//       </Switch>
//     }
//   </Router>
// );

const App = ({ authenticated, checked }) => (
  <Router>
    { checked &&
      <Switch>
        <Route path="/(login|signup|reset)/" render={props => (
          !authenticated ? (
            <Login {...props}/>
          ) : (
            <Redirect to={{
              pathname: '/',
              state: { from: props.location }
            }}/>
          )
        )}/>
        <Route path="/" render={props => (
          authenticated ? (
            <Home {...props}/>
          ) : (
            <Redirect to={{
              pathname: '/login',
              state: { from: props.location }
            }}/>
          )
        )}/>
        {/* <Route component={NoMatch}/> */}
      </Switch>
    }
  </Router>
);

const mapState = (state) => ({
  state,
  checked: state.session.checked,
  authenticated: state.session.authenticated
});

export default connect(mapState)(App);



// WEBPACK FOOTER //
// ./src/App.js